import { render } from "./BuildingInstitutionalKnowledge.vue?vue&type=template&id=735169c9"
import script from "./BuildingInstitutionalKnowledge.vue?vue&type=script&lang=js"
export * from "./BuildingInstitutionalKnowledge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__